import React from 'react';
import Axios from 'axios';
import { Form, Input, Divider, Checkbox } from 'semantic-ui-react';

class Customers extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            customers: [],
            selectedCustomer: {
                vatNumber: "",
                company: "",
                name: "",
                address: "",
                postal: "",
                city: "",
                email: "",
                personal: false
            },
            isNewCustomer: true
        }
        this.toggle = this.toggle.bind(this);
        this.loadCustomers = this.loadCustomers.bind(this);
        this.customerSelectionChanged = this.customerSelectionChanged.bind(this);
        this.companyDetailsChanged = this.companyDetailsChanged.bind(this);
        this.loadCustomers(props.member.id);
    }

    loadCustomers(memberId) {
        let self = this;
        Axios.get('http://165.227.166.190/customers/byMember/' + memberId).then((res) => {
            if (res.data) {
                self.setState({
                    customers: res.data
                });
            }
        });
    }

    customerSelectionChanged(e) {
        if (e.target.value !== "0") {
            this.state.customers.forEach((customer) => {
                if (customer.id === parseInt(e.target.value, 10)) {
                    this.setState({
                        selectedCustomer: customer,
                        isNewCustomer: false
                    });

                    setTimeout(() => {
                        this.props.onChange(customer);
                    }, 500);

                    setTimeout(() => {
                        alert("Vergeet niet alle klantgegevens te controleren, aub.");
                    }, 1000);
                }

            });
        }
        else {
            this.setState({
                selectedCustomer: {
                    vatNumber: "",
                    company: "",
                    name: "",
                    address: "",
                    postal: "",
                    city: "",
                    email: "",
                    personal: false
                },
                isNewCustomer: true
            });
        }

    }

    componentWillReceiveProps(props) {
        if (props.member.id !== this.props.member.id) {
            this.loadCustomers(props.member.id);
            this.setState({
                selectedCustomer: {
                    vatNumber: "",
                    company: "",
                    name: "",
                    address: "",
                    postal: "",
                    city: "",
                    email: "",
                    personal: false
                },
                isNewCustomer: true
            });
        }

    }

    companyDetailsChanged(e) {
        const name = e.target.name;
        const value = e.target.value;

        this.setState((prevState) => {
            let self = this;
            let customer = prevState.selectedCustomer;
            customer[name] = value;
            if (!this.state.isNewCustomer) {
                Axios.put('http://165.227.166.190/customers', customer).then((res) => {
                    self.props.onChange(customer);
                });
            }
            else {
                customer.memberId = this.props.member.id;
                Axios.post('http://165.227.166.190/customers', customer).then((res) => {

                    self.setState((prevState) => {
                        let customers = [res.data, ...prevState.customers];
                        return {
                            customers: customers,
                            selectedCustomer: res.data,
                            isNewCustomer: false
                        }
                    });
                });

            }

            return {
                selectedCustomer: customer
            }
        });
    }

    toggle() {
        this.companyDetailsChanged({
            target: {
                name: "personal",
                value: !this.state.selectedCustomer.personal
            }
        });
        this.companyDetailsChanged({
            target: {
                name: "vatNumber",
                value: ""
            }
        });
        this.companyDetailsChanged({
            target: {
                name: "company",
                value: ""
            }
        });
    }

    render() {
        return (
            <div>
                <h2>Voor welke klant wil je bestellen?</h2>

                <div>
                    <Form>
                        <Form.Field>
                            <select value={this.state.selectedCustomer.id} onChange={this.customerSelectionChanged}>
                                <option value="0">Nieuwe klant</option>
                                {
                                    this.state.customers.map((customer) => {
                                        return (
                                            customer.name && customer.company ? <option key={customer.id} value={customer.id}>{customer.company} ({customer.name})</option> : (
                                                customer.name && !customer.company ? <option key={customer.id} value={customer.id}>{customer.name}</option> : (
                                                    !customer.name && customer.company ? <option key={customer.id} value={customer.id}>{customer.company}</option> : ""
                                                )
                                            )
                                        )
                                    })
                                }
                            </select>
                        </Form.Field>
                        <Form.Field>
                            <Checkbox name="cbxPersonal" label="Particulier?" toggle checked={this.state.selectedCustomer.personal} onChange={this.toggle} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtVat">BTW nummer (BE 0xxx.xxx.xxx):</label>
                            <Input disabled={this.state.selectedCustomer.personal} id="txtVat" type="text" name="vatNumber" value={this.state.selectedCustomer.vatNumber} onChange={this.companyDetailsChanged} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtCompany">Bedrijfsnaam:</label>
                            <Input disabled={this.state.selectedCustomer.personal} id="txtCompany" type="text" name="company" value={this.state.selectedCustomer.company} onChange={this.companyDetailsChanged} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtContact">Contact naam:</label>
                            <input id="txtContact" type="text" name="name" value={this.state.selectedCustomer.name} onChange={this.companyDetailsChanged} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtAddress">Adres:</label>
                            <input id="txtAddress" type="text" name="address" value={this.state.selectedCustomer.address} onChange={this.companyDetailsChanged} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtPostal">Postcode:</label>
                            <input id="txtPostal" type="text" name="postal" value={this.state.selectedCustomer.postal} onChange={this.companyDetailsChanged} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtCity">Plaats:</label>
                            <input id="txtCity" type="text" name="city" value={this.state.selectedCustomer.city} onChange={this.companyDetailsChanged} />
                        </Form.Field>
                        <Form.Field>
                            <label htmlFor="txtEmail">Email:</label>
                            <input id="txtEmail" type="email" name="email" value={this.state.selectedCustomer.email} onChange={this.companyDetailsChanged} />
                        </Form.Field>

                    </Form>

                </div>
                <Divider />
            </div>
        );
    }

}

export default Customers;


// WEBPACK FOOTER //
// ./src/components/customers/customers.js